<div class="impersonate-container">
  <p *ngIf="isLoading">Logging you in...</p>
  <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>
</div>
